export default "__VITE_ASSET__CFgj0drI__"